import api from '@/api'
import lodash from 'lodash'
import domainUtil from '@/utils/domain'

const controller = {
  entity: 'checksheet',
  createOne: () => ({
    entity: controller.entity,
    author: '',
    type: '',
    meta: {},
    date: '',
    reg_date: new Date(),
    last_updated: new Date()
  })
}

export default {
  namespaced: true,
  state: {
    data: {
      meta: {},
      factors: [],
      freezed: false
    },
    stations: []
  },
  mutations: {
    rebuildStations (state) {
      state.stations = domainUtil.equipment.buildStations(state.data.factors)
    },
    update (state, data) {
      lodash.extend(state.data, data)
    },
    freeze (state) {
      state.data.freezed = true
    },
    clear (state) {
      state.data = {factors: []}
    }
  },
  actions: {
    async load (context, {equipment, ymd}) {
      context.commit('clear')
      if (!equipment || !ymd) { return }
      context.state.data = await findForKey(buildKey(equipment, ymd)) || await createEmptyData(context, equipment, ymd)
      context.commit('rebuildStations')
    },
    async updateAndSave (context, data) {
      lodash.extend(data, {author: context.rootState.user.data._id})
      const res = await api.putBIZ('/api/content', {uri: data._id, content: data})
      data._rev = (res.data.shift() || {}).rev
      context.commit('update', data)
    },
    async uploadAttachment (context, {data, attachment, idx}) {
      const query = encodeURIComponent(`${data._id}/${idx}?rev=${data._rev}`)
      const fd = new FormData()
      fd.append('file', attachment)
      const {data: {rev}} = await api.putBIZ(`/api/content/attachment?uri=${query}`, fd)
      data._rev = rev
    },
    async deleteAttachment (context, {data, idx}) {
      const query = encodeURIComponent(`${data._id}/${idx}?rev=${data._rev}`)
      const {data: {rev}} = await api.deleteBIZ(`/api/content/attachment?uri=${query}`)
      data._rev = rev
    },
    async downloadAttachment (context, {data, idx}) {
      const query = encodeURIComponent(`${data._id}/${idx}`)
      await api.downloadBIZ(`/api/content/attachment?uri=${query}`, {params: {filename: idx}}, 'GET')
    },
    async getAttachment (context, {data, idx}) {
      const query = encodeURIComponent(`${data._id}/${idx}`)
      const res = await api.request(api.host_biz, `/api/content/attachment?uri=${query}`, {method: 'GET', responseType: 'blob'})
      return res
    }
  }
}

const buildKey = (equipment, ymd) => `${equipment}_${ymd}`
const findForKey = (key) => find({selector: {key}})

const createEmptyData = async (context, equipment, ymd) => {
  const referenceDate = context.rootState.settings.data.checksheet_reference_date + ymd.substring(8)
  const key = buildKey(equipment, ymd)
  const reference = await findForKey(buildKey(equipment, referenceDate)) || await loadLedger(equipment)
  const content = controller.createOne()
  lodash.extend(content, {date: ymd, key, meta: {equipment}, factors: reference.factors.map(f => { delete f.value; return f })})
  await api.putBIZ(`/api/content`, {content})
  const res = await findForKey(key)
  return res
}

const loadLedger = (title) => find({selector: {entity: 'equipment_ledger', title}})

const find = async (q) => {
  q.selector = q.selector || {selector: {}}
  q.selector.entity = q.selector.entity || controller.entity
  const res = await api.postBIZ('/api/content/find', lodash.extend(q))
  return ((res || {data: []}).data || []).shift()
}



// WEBPACK FOOTER //
// ./src/store/modules/checkSheet.js